export const isMobile = () => window.outerWidth < 813;
